import React from 'react';
import paper from '../ReportPaper.module.css';
import AimsTable from '../../../../pages/appointment/components/aims/AimsTable';
import AimsChart, { chartPoints } from '../../../../pages/appointment/components/aims/AimsChart';
import styles from '../../../../pages/appointment/components/aims/aims.module.css';
import { AIMS_ATTRIBUTION, BAND_NOTE, TOTAL_MAX, formatAge, formatDate, formatPercentile, gestationalNote } from '../../../../pages/appointment/modules/aims/aims';

/**
 * Miolo do PDF da escala de Alberta: resumo da avaliação em destaque (idade,
 * total, percentil, faixa), a evolução do total, o histórico do paciente e a
 * atribuição. O gráfico mostra só os pontos do paciente: os itens e as curvas
 * da escala não são reproduzidos.
 *
 * Recebe o job de buildAimsJob.
 */
const AimsReportBody = ({ rows, featured, birthInfo }) => {
  const summary = [
    featured.age && `Idade: ${formatAge(featured.age)}`,
    `Total: ${featured.total}/${TOTAL_MAX}`,
    `Percentil: ${formatPercentile(featured.record.percentile)}`,
    featured.band && featured.band.label,
    gestationalNote(birthInfo),
  ].filter(Boolean);

  return (
    <>
      <div className={paper.section}>
        <div className={paper.noteBox}>{`Avaliação de ${formatDate(featured.record.assessedAt)} · ${summary.join(' · ')}`}</div>
      </div>

      {chartPoints(rows).length > 1 && (
        <div className={paper.section}>
          <div className={paper.sectionTitle}>Evolução do total</div>
          <AimsChart rows={rows} highlightId={featured.record.id} />
        </div>
      )}

      <div className={paper.section}>
        <div className={paper.sectionTitle}>Histórico de avaliações</div>
        <AimsTable rows={rows} classes={{ table: paper.table }} />
      </div>

      {featured.record.notes && (
        <div className={paper.section}>
          <div className={paper.sectionTitle}>Observações</div>
          <div className={paper.noteBox}>{featured.record.notes}</div>
        </div>
      )}

      <span className={styles.footnote}>{BAND_NOTE} {AIMS_ATTRIBUTION}</span>
    </>
  );
};

export default AimsReportBody;
